import { MatchFail, MatchSucess } from './types';

export const FAIL: MatchFail = [false, {}];
export const SUCCESS: MatchSucess = [true, {}];
